import {
  FETCH_BOOKINGS_DATA,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  FETCH_BOOKINGS_DETAILS_DATA,
  FETCH_BOOKINGS_DETAILS_SUCCESS,
  FETCH_BOOKINGS_DETAILS_FAILURE,
} from "./actionTypes";

export const fetchBookingsData = (driverId) => ({
  type: FETCH_BOOKINGS_DATA,
  driverId: driverId
});

export const fetchBookingsSuccess = (data) => ({
  type: FETCH_BOOKINGS_SUCCESS,
  payload: data,
});

export const fetchBookingsFailure = (error) => ({
  type: FETCH_BOOKINGS_FAILURE,
  payload: error,
});

export const fetchBookingsDetailsData = (id) => ({
  type: FETCH_BOOKINGS_DETAILS_DATA,
  payload: id,
});

export const fetchBookingsDetailsSuccess = (data) => ({
  type: FETCH_BOOKINGS_DETAILS_SUCCESS,
  payload: data,
});

export const fetchBookingsDetailsFailure = (error) => ({
  type: FETCH_BOOKINGS_DETAILS_FAILURE,
  payload: error,
});
